import { defineNuxtPlugin } from '#imports'
import { useMetaPixel } from '~/composables/useMetaPixel'

export default defineNuxtPlugin((nuxtApp: any) => {
    // Ensure this plugin only runs on the client side.
    if (process.client) {
        // Hook into Nuxt's app:mounted event.
        // This runs when the root Vue component has been mounted.
        nuxtApp.hook('app:mounted', async () => {
            // Get the Meta Pixel composable instance.
            const pixel = useMetaPixel();

            // Enable automatic SPA page tracking (router navigation).
            pixel.enableAutoTracking();

            // Load configuration.
            const cfg = await pixel.loadConfig();

            // If the Meta Pixel feature is disabled in config, exit early.
            if (!cfg.enabled) return;

            const route = useRoute();

            // Initialize pixels from the API configuration once it's loaded.
            pixel.initPixels();

            // Firing the initial track page event.
            pixel.trackPageView(route.path);
        });
    }
})
